module.exports = __webpack_public_path__ + "static/media/cha-guya-name.ffcfbca5.svg";